import {Mapper} from '@s-ui/domain'

import {DEFAULT_CULTURE, TIMEZONE_BY_CULTURE} from '../../config/base.js'

export default class FromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper extends Mapper {
  constructor({marketedVersionsListValueObject, marketedVersionValueObject}) {
    super()
    this._marketedVersionsListValueObject = marketedVersionsListValueObject
    this._marketedVersionValueObject = marketedVersionValueObject
  }

  // Fixed culture and zone: the server default (en-US, UTC) printed US dates and could shift the day
  _parseDate = date =>
    new Date(date).toLocaleDateString(DEFAULT_CULTURE, {timeZone: TIMEZONE_BY_CULTURE[DEFAULT_CULTURE]})

  map = ({marketedVersionsList}) => {
    const items = marketedVersionsList.map(({price, url, initDate, endDate}) =>
      this._marketedVersionValueObject({
        price,
        url,
        initDate: this._parseDate(initDate),
        endDate: endDate && this._parseDate(endDate)
      })
    )

    return this._marketedVersionsListValueObject({items})
  }
}
